export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M14.996 8.348l-2.557 2.47a.45.45 0 01-.763-.332l.032-1.811H6.932a.675.675 0 110-1.35h4.8l.032-1.865a.45.45 0 01.774-.305l2.47 2.557a.45.45 0 01-.012.636z\" fill=\"#6F7488\"/><path d=\"M11.145 12.755c.19.292.108.685-.202.845a6.299 6.299 0 11-.117-11.259c.312.153.402.544.219.84-.184.296-.57.383-.887.238a5.04 5.04 0 10.095 9.117c.313-.152.702-.072.892.22z\" fill=\"#6F7488\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 16 16",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};